import { useMemo } from "react";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";

export function useStagingStyles() {
  return useMemo(
    () => mergeStyleSets({
      root: {
        "& .ms-Panel-scrollableContent": {
          height: `100%`,
          overflow: `hidden`
        },
        "& .ms-Panel-commands": {
          zIndex: 1
        },
        "& .ms-Panel-content": {
          height: `calc(100% - 70px)`,
          overflow: `hidden`
        },
        "& .ms-Panel-navigation > button": {
          marginRight: `20px`,
          background: `transparent`
        }
      },
      container: {
        paddingTop: `20px`,
        height: `100%`,
        overflow: `hidden`,
        overflowY: `scroll`
      },
      footer: {
        height: `30px`
      }
    }),
    []
  );
}
